import { useSearchParams } from "react-router-dom"
import { useDrawingSpecificationKeywordsConfig } from "hooks/api/drawings/drawings.hook"
import { FileInfoKeywords } from "../../../FileInfoKeywords/FileInfoKeywords"
import type { TDrawingStatusProps } from "types/drawer.type"

export const ConfigurationSpecificationKeywords = ({ drawingStatus }: TDrawingStatusProps) => {
	const [searchParams] = useSearchParams()

	const drawingId = Number(searchParams.get("drawingID"))
	const processingId = Number(searchParams.get("processingID"))

	const {
		data: specificationKeywords,
		isPending: isSpecificationKeywordsPending,
		isError: errorFetchingSpecificationKewords,
	} = useDrawingSpecificationKeywordsConfig(drawingId, processingId, drawingStatus)

	return (
		<FileInfoKeywords
			drawingKeywords={specificationKeywords}
			isKeywordsPending={isSpecificationKeywordsPending}
			errorFetchingKewords={errorFetchingSpecificationKewords}
		/>
	)
}
